import XHR         from "_common/xhr";
import { configs } from "_config/index";

export const getUserRoles = async function () {
	const response = await XHR.get.bind ( this ) ( {
		url: `${ configs.USER_SRV }user/roles`
	} );

	return response;
};

export const getCreatorPlusPlans = async function ( { countryCode, screen } ) {
	const response = await XHR.get.bind ( this ) ( {
		url: `${ configs.USER_SRV }creator_plus/plans?countryCode=${ countryCode }`
	} );

	return response;
};

export const getPaymentMethods = async function ( { countryCode } ) {
	const response = await XHR.get.bind ( this ) ( {
		url: `${ configs.USER_SRV }pro/paymentMethods?countryCode=${ countryCode }`
	} );

	return response;
};

export const getPlusPurchaseHistory = async function ( { pageNo = 1, pageSize = 10 } ) {
	const response = await XHR.get.bind ( this ) ( {
		url: `${ configs.USER_SRV }creator_plus/orders/history?pageNo=${ pageNo }&pageSize=${ pageSize }`
	} );

	return response;
};

export const getPlusPurchaseDetails = async function ( { id } ) {
	const response = await XHR.get.bind ( this ) ( {
		url: `${ configs.USER_SRV }creator_plus/orders/${ id }`
	} );

	return response;
};

export const initOrder = async function ( params ) {
	const response = await XHR.post.bind ( this ) ( {
		url  : `${ configs.USER_SRV }creator_plus/orders`,
		data : {
			planId   : params?.planId,
			merchant : params?.merchant
		}
	} );

	return response;
};

export const createSupportTicket = async function ( { email, orderId, description } ) {
	const response = await XHR.put.bind ( this ) ( {
		url  : `${ configs.USER_SRV }pro/support`,
		data : {
			email,
			orderId,
			description
		}
	} );

	return response;
};

export const getUserPlusPlan = async function () {
	const response = await XHR.get.bind ( this ) ( {
		url: `${ configs.USER_SRV }creator_plus/current_plan`
	} );

	return response;
};

export const getStreamsToBeDeleted = async function ( { pageNo = 1, pageSize = 20 } ) {
	const response = await XHR.get.bind ( this ) ( {
		url: `${ configs.USER_SRV }creator_plus/streams_deleting?pageNo=${ pageNo }&pageSize=${ pageSize }`
	} );

	return response;
};
